import {ReactNode} from 'react';
import {ScrollableHorizontalList} from '../../../molecules/ScrollableHorizontalList/ScrollableHorizontalList';

export interface ItemListProps {
  children: ReactNode;
  isMobile: boolean;
}

export function ItemList({children, isMobile}: ItemListProps) {
  return (
    <div className="w-full pb-10pxr">
      <ScrollableHorizontalList
        isMobile={isMobile}
        hideArrow={!!isMobile}
        gapPx={8}
        className="pb-8pxr"
        innerLeftPx={18}
        innerRightPx={18}
      >
        {children}
      </ScrollableHorizontalList>
    </div>
  );
}
